import React from 'react';

/**
 * Icono Plus (heroicons-micro/plus)
 * Usado en el botón "Agregar" del POSProductCard
 * Tamaño: 16x16px según especificación de Figma
 */
export const PlusIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M8 3V13M3 8H13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
